import { DialogsRenderer } from '../components/widgets/dialog';
import { NotificationToasterRenderer } from '../components/widgets/notificationToaster';
import React, { FC, FunctionComponent, Suspense } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import styled, { ThemeProvider } from 'styled-components';
import ErrorPageBoundary from '../components/pages/_error';
import OverlayLoading from '../components/widgets/overlayLoading';
import { AppStateProvider } from '../shared/appState';
import { scrollbarsStyle } from '../shared/globals';
import theme from '../shared/theme';

const Container = styled.div`
    font-size: 14px;
    font-family: ${(props) => props.theme.app.font};
    color: ${(props) => props.theme.app.primary};
    min-height: 100%;
    padding: 0px;

    ${scrollbarsStyle}
`;

const ScrollTop: FC<{ children?: React.ReactNode }> = ({ children }) => {
    return <React.Fragment>{children}</React.Fragment>;
};

export const GuestLayoutContainer: FunctionComponent<{ className?: string; children?: React.ReactNode }> = ({ className, children }) => {
    return (
        <AppStateProvider>
            <ThemeProvider theme={theme}>
                <NotificationToasterRenderer />
                <Container className={className}>
                    <ErrorPageBoundary>
                        <Router>
                            <ScrollTop>
                                <Suspense fallback={<OverlayLoading forceShow />}>
                                    {children}
                                    <DialogsRenderer />
                                    <OverlayLoading />
                                </Suspense>
                            </ScrollTop>
                        </Router>
                    </ErrorPageBoundary>
                </Container>
            </ThemeProvider>
        </AppStateProvider>
    );
};
